var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pull-to',{attrs:{"top-load-method":_vm.onLoad,"topConfig":_vm.topConfig}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }